import { useState } from "react";
import AtkLoader from "../../../AtlaskitControls/AtkLoader";
import { InputTextarea } from "primereact/inputtextarea";
import Base64Image from "../Template-1/Base64Image";

export default function ProposalCover(props: any) {
  const [isPreparedForEditing, setIsPreparedForEditing] = useState(false);
  const [isPreparedByEditing, setIsPreparedByEditing] = useState(false);
  const [isTitleEditing, setIsTitleEditing] = useState(false);

  return (
    <div className="container p-0  border mt-2">
      <section className="section-proposal p-5">
        <div className="container">
          <div className="row d-flex align-items-center justify-content-center flex-column text-center">
            {/* <img className="w-auto" height={60} src={props.logoURL} alt="" /> */}
            <Base64Image imageUrl={props.logoURL || ""} className="w-auto" height="60" alt="Insurance Image" />

            {props.isEditable && !props.isGeneratingPdf ? (
              <>
                {!isPreparedForEditing ? (
                  <i className="fa fa-pencil text-12 ms-2 show-cursor text-end" title="Edit" onClick={() => setIsPreparedForEditing(true)} />
                ) : (
                  <span className="text-12 text-end">
                    {isPreparedForEditing && props.saveLoading ? (
                      <div className="d-inline-flex align-items-center">
                        <AtkLoader />
                      </div>
                    ) : (
                      <i
                        className="fa fa-check mx-2 show-cursor text-success"
                        onClick={() => {
                          setIsPreparedForEditing(false);
                          props.onTemplateDetailsSave();
                        }}
                        title="Save"
                      />
                    )}
                    <i
                      className="fa fa-times show-cursor text-danger"
                      title="Cancel"
                      onClick={() => {
                        setIsPreparedForEditing(false);
                        props.onCancelTemplateDetailsToSave();
                      }}
                    />
                  </span>
                )}
              </>
            ) : null}
            {isPreparedForEditing ? (
              <InputTextarea value={props.preparedFor} onChange={props.onPreparedForChange} autoResize className="text-12 w-100 my-2" />
            ) : (
              <h3 className="fw-bold ">
                Proposal for <span style={{ color: props.primaryColor }}>{props.preparedFor}</span>
              </h3>
            )}
            {props.isEditable && !props.isGeneratingPdf ? (
              <>
                {!isPreparedByEditing ? (
                  <i className="fa fa-pencil text-12 ms-2 show-cursor text-end" title="Edit" onClick={() => setIsPreparedByEditing(true)} />
                ) : (
                  <span className="text-12 text-end">
                    {isPreparedByEditing && props.saveLoading ? (
                      <div className="d-inline-flex align-items-center">
                        <AtkLoader />
                      </div>
                    ) : (
                      <i
                        className="fa fa-check mx-2 show-cursor text-success"
                        onClick={() => {
                          setIsPreparedByEditing(false);
                          props.onTemplateDetailsSave();
                        }}
                        title="Save"
                      />
                    )}
                    <i
                      className="fa fa-times show-cursor text-danger"
                      title="Cancel"
                      onClick={() => {
                        setIsPreparedByEditing(false);
                        props.onCancelTemplateDetailsToSave();
                      }}
                    />
                  </span>
                )}
              </>
            ) : null}
            {isPreparedByEditing ? (
              <div className="">
                <InputTextarea value={props.preparedBy} onChange={props.onPreparedByChange} autoResize className="text-12 w-100 my-2" />
              </div>
            ) : (
              <p className="fs-5 text-secondary mt-0">
                Prepared By: <span className="text-dark">{props.preparedBy}</span>
              </p>
            )}
          </div>
        </div>
      </section>

      <div className="position-relative" style={{ height: "400px", overflow: "hidden" }}>
        {/* <img
    src={props.templateImages?.split(",")[0]}
    alt="Background"
    className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
    style={{ zIndex: 0 }}
  /> */}
        <Base64Image
          imageUrl={props.templateImages?.split(",")[0] || ""}
          className="temp2-bg-img"
          alt="Insurance Image"
         style={{ zIndex: 0 }}
        />

        <div className="section-overlay cmn-overlay" style={{ zIndex: 1 }}></div>

        <div className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center" style={{ zIndex: 2 }}>
          <h2 className="text-light  d-flex flex-col align-items-center">
            {isTitleEditing ? (
              <span>
                <InputTextarea value={props.title} onChange={props.onTitleChange} autoResize className="text-12 w-100 my-2" />
              </span>
            ) : (
              <span className="">{props.title}</span>
            )}
            {props.isEditable && !props.isGeneratingPdf ? (
              <>
                {!isTitleEditing ? (
                  <i className="fa fa-pencil text-12 ms-2 show-cursor text-end" title="Edit" onClick={() => setIsTitleEditing(true)} />
                ) : (
                  <span className="text-12 text-end">
                    {isTitleEditing && props.saveLoading ? (
                      <div className="d-inline-flex align-items-center">
                        <AtkLoader />
                      </div>
                    ) : (
                      <i
                        className="fa fa-check mx-2 show-cursor text-success"
                        onClick={() => {
                          setIsTitleEditing(false);
                          props.onTemplateDetailsSave();
                        }}
                        title="Save"
                      />
                    )}
                    <i
                      className="fa fa-times show-cursor text-danger"
                      title="Cancel"
                      onClick={() => {
                        setIsTitleEditing(false);
                        props.onCancelTemplateDetailsToSave();
                      }}
                    />
                  </span>
                )}
              </>
            ) : null}
          </h2>
        </div>
      </div>
    </div>
  );
}
